import { list } from '@/router/utils'
import { AttachmentUploader } from '@/shared/components/attachment-uploader'
import { LinkWithQuery } from '@/shared/components/link-with-query'
import { useGetAttachmentTypesQuery } from '@/store/services/attachment-type.service'
import {
  useCreateAttachmentMutation,
  useGetAttachmentsQuery,
  useUpdateAttachmentMutation
} from '@/store/services/attachment.service'
import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader
} from '@material-tailwind/react'
import { FiArrowLeft } from 'react-icons/fi'
import {
  createSearchParams,
  useLoaderData,
  generatePath,
  Link
} from 'react-router-dom'

export const ContractAttachmentsUpload = () => {
  const { contract: currentContract } = useLoaderData()

  const attachmentSearchParams = createSearchParams({
    attachable_type: 'Contractor::Contract',
    attachable_id: currentContract.id,
    per_page: 9999,
    'sorter[field]': 'id',
    'sorter[order]': 'desc'
  })

  const attachmentTypeSearchParams = createSearchParams({
    per_page: 9999,
    klass: 'Contractor::Contract',
    'service_area_ids[]': currentContract.company.serviceAreas.map(
      (serviceArea) => serviceArea.id
    )
  })

  const { data: { attachmentTypes = [] } = {} } = useGetAttachmentTypesQuery(
    `?${attachmentTypeSearchParams}`
  )

  const {
    data: { attachments = [], meta = {} } = {},
    isLoading: isLoadingAttachments
  } = useGetAttachmentsQuery(`?${attachmentSearchParams}`)

  const [updateAttachment] = useUpdateAttachmentMutation()
  const [createAttachment] = useCreateAttachmentMutation()

  const onUpload = async (params) => {
    try {
      if (params?.id) {
        await updateAttachment(params).unwrap()
      } else {
        await createAttachment({ ...params, attachable_type: 'Contractor::Contract', attachable_id: currentContract.id }).unwrap()
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Dialog size='lg' open>
      <DialogHeader className='pb-0'>
        <Link
          to={generatePath('/contracts/:id/attachments/list', {
            id: currentContract.id
          })}
        >
          <Button size='sm' className='w-fit flex items-center' variant='text'>
            <FiArrowLeft size='16px' className='mr-2' />
            Volver
          </Button>
        </Link>
      </DialogHeader>

      <DialogBody>
        {!isLoadingAttachments && (
          <AttachmentUploader
            attachmentTypes={attachmentTypes}
            showLatestAttachments
            attachments={attachments}
            onUpload={onUpload}
          >
            {(handleSubmit) => (
              <Button
                className='w-fit'
                variant='outlined'
                onClick={handleSubmit}
              >
                Agregar documento
              </Button>
            )}
          </AttachmentUploader>
        )}
      </DialogBody>

      <DialogFooter>
        <LinkWithQuery to={list('contracts')}>
          <Button
            variant='outlined'
            color='gray'
          >
            Salir
          </Button>
        </LinkWithQuery>
      </DialogFooter>
    </Dialog>
  )
}
